import React from "react";
import {Switch, Route, Redirect, useParams, useRouteMatch} from "react-router-dom";
import ManagerTopBar from "../../Components/ManagerTopBar";
import TabScreen from "../../Components/TabScreen";
import GroupSidebar from "../../Components/GroupSidebar";
import Inbox from "../Inbox";
import GroupSettings from "../GroupSettings";
import Members from "../Members";
import OperatorAccess from "../OperatorAccess";
import {GroupManagerProvider} from "../../Providers/groupManager";
import {Container, Content} from "./styles";

/**
 * Shell da tela Group Manager (full-screen).
 * Envolve o conteúdo no GroupManagerProvider (dados da campanha/número) e
 * renderiza a barra de topo + a área de conteúdo, que troca conforme a sub-rota.
 */
const GroupManager = () => {
    const {id} = useParams();
    // path mantém o placeholder ":id" (ex.: /campaign/:id/manager) para as sub-rotas,
    // preservando o param dentro do Inbox/GroupList (useParams().id).
    // base é a URL concreta (com o id resolvido) usada só no redirect.
    const {path} = useRouteMatch();
    const base = `/campaign/${id}/manager`;

    return (
        <GroupManagerProvider>
            <Container>
                <ManagerTopBar/>
                <Content>
                    <Switch>
                        <Redirect exact from={base} to={`${base}/inbox`}/>
                        <Route path={`${path}/inbox`}
                               render={() => <Inbox/>}/>
                        <Route path={`${path}/settings`}
                               render={() => (
                                   <TabScreen sidebar={<GroupSidebar/>}>
                                       <GroupSettings/>
                                   </TabScreen>
                               )}/>
                        <Route path={`${path}/members`}
                               render={() => (
                                   <TabScreen sidebar={<GroupSidebar/>}>
                                       <Members/>
                                   </TabScreen>
                               )}/>
                        <Route path={`${path}/operators`} render={() => <OperatorAccess/>}/>
                    </Switch>
                </Content>
            </Container>
        </GroupManagerProvider>
    );
};

export default GroupManager;
